import script from "./PdfViewerModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./PdfViewerModal.vue?vue&type=script&lang=ts&setup=true"

import "./PdfViewerModal.vue?vue&type=style&index=0&id=5bd05a34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bd05a34"]])

export default __exports__